<template>
  <div class="autonomous-file-chip-list">
    <FileChipList
      :limit="limit"
      :column="column"
      :editable="!disabled && editable"
      :value="value"
      @chipClick="onChipClick"
      @addFile="openFileViewer(0, true)"
      @input="$emit('input', $event)"
    />
    <transition name="fade">
      <FileViewer
        v-if="fileViewerVisible"
        ref="fileViewer"
        :value="value"
        :editable="!disabled && editable"
        :index="fileViewerIndex"
        :pathname="pathname"
        @input="$emit('input', $event)"
        @close="fileViewerVisible = false"
      />
    </transition>
  </div>
</template>

<script>
/**
 * FileChipList and FileViewer in a single component in order to have a fully autonomous component.
 * All FileChipList and FileViewer props are re-usable from this component.
 *
 * @vue-prop {Boolean} [disabled] - If true, prevents any interaction with the component and overides 'editable' prop
 */

// Import components
import FileChipList from '@/components/file-system/file-chip-list.vue';
import FileViewer from '@/components/file-system/file-viewer.vue';

export default {
  name: 'AutonomousFileChipList',

  components: {
    FileChipList,
    FileViewer,
  },

  props: {
    column: Boolean,
    editable: Boolean,
    forceButtonText: Boolean,
    disabled: Boolean,
    pathname: {
      type: String,
      required: true,
    },
    limit: {
      type: Number,
      default: Infinity,
      validator: v => v >= 0,
    },
    value: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      fileViewerVisible: false,
      fileViewerIndex: 0,
    };
  },

  methods: {
    /** Chip clicked: open the file viewer to display, download  or edit the file */
    onChipClick(event) {
      if (this.disabled) {
        return;
      }
      let index;
      if (event.file) {
        index = this.value.indexOf(event.file.id);
      }
      this.openFileViewer(index);
    },
    /**
     * Open file viewer to display, download or edit file attachments of the new info
     * @param {Number} [index=0] - Index of the file to display first
     * @param {Number} [forceAdd] - Force add dialog after opening the file viewer
     */
    openFileViewer(index = 0, forceAdd) {
      if (this.disabled) {
        return;
      }
      this.fileViewerIndex = index;
      this.fileViewerVisible = true;
      if (forceAdd || !(this.value.length > 0)) {
        this.$nextTick(() => {
          this.$refs.fileViewer.addFile();
        });
      }
    },
  },
};
</script>
